@let title =
  config().subHeader.useProductLabel
    ? challenge().productScope.label[shortLocale]
    : challenge().productScope.description[shortLocale];

<div class="card" [style]="config().cardStyles" [id]="challenge().offerId">
  <!-- Additional Info -->
  @let additionalInfo = config().header.additionalInfo;
  @if (additionalInfo) {
    <p
      class="additional-information"
      [style]="{
        color: additionalInfo.color,
        fontFamily: additionalInfo.fontFamily,
        backgroundColor:
          challenge().subType === SubType.DEFAULT
            ? additionalInfo.backgroundColor
            : additionalInfo.specialBackgroundColor,
      }"
    >
      {{ challenge().productScope.label[shortLocale] }}
    </p>
  }
  <div
    class="un-card-header"
    [style]="{
      height: config().header.height,
      backgroundColor: config().header.backgroundColor,
    }"
  >
    <!-- Banner -->
    @if (challenge().hasBanner()) {
      <div class="banner">
        @if (loadBannerInPriority()) {
          <img
            fill
            priority
            class="img responsive-width"
            [alt]="config().bannerAlternativeText"
            [ngSrc]="challenge().productScope.bannerPath!"
          />
        } @else {
          <img
            fill
            class="img responsive-width"
            [alt]="config().bannerAlternativeText"
            [ngSrc]="challenge().productScope.bannerPath!"
          />
        }
      </div>
    }

    <!-- Logo -->
    @if (!challenge().hasBanner()) {
      <div class="logo-container">
        <div class="box">
          <img
            class="logo"
            [alt]="config().logoAlternativeText"
            [src]="challenge().productScope.logoPath"
          />
        </div>
      </div>
    }
  </div>

  <div
    class="card-subheader"
    [class.card-subheader-completed]="challenge().isCompleted"
    [style]="{
      color: config().subHeader.color,
      fontFamily: config().subHeader.fontFamily,
      fontSize: config().subHeader.fontSize,
      backgroundColor: challenge().isCompleted
        ? config().subHeader.completedBackgroundColor
        : config().subHeader.backgroundColor,
    }"
  >
    <p
      class="label"
      b2cTooltipIfTruncated
      [b2cTooltipHideDelay]="80"
      [b2cTooltipShowDelay]="120"
      [b2cTooltipPosition]="'above'"
      [b2cTooltip]="title.toString()"
    >
      {{ title }}
    </p>
    @let subHeaderIcon = config().subHeader.icon;
    @let isSubHeaderInfoIconVisible =
      config().subHeader.hasInfoButton !== false &&
      !challenge().isCompleted &&
      phase() !== CampaignPhase.COMPLETED &&
      !!subHeaderIcon &&
      (challenge().isSelected ||
        (!challenge().isSelected && !subHeaderIcon.displayWhenSelected));
    @if (isSubHeaderInfoIconVisible && subHeaderIcon) {
      <b2c-icon
        b2cElement
        modalType="scanner"
        class="icon"
        data-cy="check_product_btn"
        [icon]="subHeaderIcon.imageUrl"
        [disabled]="this.challenge().isOutOfStock()"
        [buttonTitle]="subHeaderIcon.title || subHeaderIcon.alternativeText"
        (click)="displayDialog(challenge(), title.toString())"
      />
    }
    @if (
      config().subHeader.showUnselectionButtonInSubHeader &&
      challenge().canBeUnselected(phase())
    ) {
      <b2c-unselection-button
        [phase]="phase()"
        [challenge]="challenge()"
        class="subheader-unselect-challenge"
        [isBisCampaign]="isBisCampaign()"
        [isEventChallenge]="isEventChallenge()"
      />
    }
  </div>

  <div class="bottom">
    <!-- Win Card -->
    @if (challenge().isCompleted) {
      <b2c-win-card
        class="win-container"
        [amount]="challenge().maxPotentialReward"
      />
    } @else {
      <div class="card-content">
        <b2c-progress-section
          [config]="config()"
          [challenge]="challenge()"
          [class.one-two-steps]="challenge().targets.length < 3"
        />
      </div>

      @let footer = config().footer;
      <div
        class="card-footer"
        [class.has-credit-info]="footer.creditInfo"
        [style.color]="footer.color"
      >
        <div class="footer-row">
          @if (footer.icon.imageUrl) {
            <img
              class="icon"
              [src]="footer.icon.imageUrl"
              [alt]="footer.icon.alternativeText"
            />
          }
          <p
            class="label"
            [style]="{
              color: footer.color,
              fontFamily: footer.fontFamily,
            }"
          >
            {{ footer.label }}:
          </p>
          <div
            class="amount-spent"
            [style.fontFamily]="footer.spentAmountFontFamily"
          >
            {{ challenge().progress | formatAmount: 'currency' }}
          </div>
        </div>

        @let creditInfo = footer.creditInfo;
        @if (creditInfo) {
          <p
            class="credit-info"
            [style]="{
              color: creditInfo.color,
              fontFamily: creditInfo.fontFamily,
            }"
          >
            {{ creditInfo.label }}
          </p>
        }

        @let productCheckButton = config().footer.productCheckButton;
        @if (
          challenge().isSelected &&
          phase() !== CampaignPhase.COMPLETED &&
          productCheckButton
        ) {
          <button
            b2cElement
            type="button"
            modalType="scanner"
            class="eligible-products"
            [attr.data-cy]="
              isSubHeaderInfoIconVisible
                ? 'eligible_products_btn'
                : 'check_product_btn'
            "
            (click)="displayDialog(challenge(), title.toString())"
            [attr.aria-label]="productCheckButton.ariaLabel"
            [title]="productCheckButton.ariaLabel"
            [style]="{
              color: productCheckButton.color,
            }"
          >
            <!-- Label -->
            <p class="label" [style.fontFamily]="productCheckButton.fontFamily">
              {{ productCheckButton.label }}
            </p>
          </button>
        }

        <!-- Unselect Button -->
        @if (
          !config().subHeader.showUnselectionButtonInSubHeader &&
          challenge().canBeUnselected(phase())
        ) {
          <b2c-unselection-button
            [phase]="phase()"
            [challenge]="challenge()"
            class="unselect-challenge"
            [isBisCampaign]="isBisCampaign()"
            [isEventChallenge]="isEventChallenge()"
          />
        }
      </div>
    }

    <!-- Selection Button -->
    @if (!challenge().isSelected) {
      <b2c-selection-button
        b2cElement
        [phase]="phase()"
        [challenge]="challenge()"
        class="selection-section"
        [isBisCampaign]="isBisCampaign()"
        [isEventChallenge]="isEventChallenge()"
        [style.backgroundColor]="config().selectionButtonbackgroundColor"
      />
    }
  </div>
</div>
